import { useQuery } from "@tanstack/react-query";
import { fetchUsers } from "../services/usersServices";

const useUsers = () => {
  return useQuery({
    queryKey: ["users-list"],
    queryFn: fetchUsers,
    staleTime: Infinity,
    refetchOnWindowFocus: false,
  });
};

export default useUsers;
